import { ChatIcon } from "@enkor/design/icons";
import { grayScale } from "@enkor/design/colors";

import * as S from "./NoCommentPlaceholder.style";

const NoCommentPlaceholder = () => {
  return (
    <S.Container>
      <ChatIcon strokeColor={grayScale[700]} />
      <S.Phrase name="h6">
        No comments yet. Be the first to leave a comment.
      </S.Phrase>
    </S.Container>
  );
};

export default NoCommentPlaceholder;
